import { baseVueI18n } from '@/plugins/vue-i18n'
import { BaseTableEntities } from '@/types'

const authTables: BaseTableEntities = {
  access: [
    {
      value: 'module',
      text: '',
      formatter: (value) => value ? baseVueI18n.t(`app.module.${value.name}`) : value
    }
  ]
}

export default authTables